export default function Loading() {
  return (
      <div id="container" className="background_layer">
        <div id="contents_header"></div>
        <div id="contents_body">
          <div className="loading"></div>
        </div>
      </div>
    );
}
